import { GoTrash } from "react-icons/go";
import { FaXmark } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import Multiselect from "multiselect-react-dropdown";
import TextEditor from "../../../PageSettings/TextEditor";
import { FiDollarSign, FiPlus, FiPlusSquare } from "react-icons/fi";
import { storeProductServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeProductServices";
import { storeCategoryServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCategoryServices";
import { storeSubCategoryServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeSubCategoryServices";
import {
  Form,
  Button,
  Row,
  Col,
  Container,
  Card,
  Stack,
  ListGroup,
  InputGroup,
} from "react-bootstrap";

const AddStoreProduct = ({ getStoreProductList, setAddNewProduct }) => {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("draft");
  const [thumbnail, setThumbnail] = useState(null);
  const [galary, setGalary] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [tags, setTags] = useState([]);
  const [productType, setProductType] = useState("");
  const [regularPrice, setRegularPrice] = useState("");
  const [salePrice, setSalePrice] = useState("");
  const [inventorySettings, setInventorySettings] = useState({});
  const [shipplingSettings, setShipplingSettings] = useState({});
  const [relatedProduct, setRelatedProduct] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [downloadURL, setDownloadURL] = useState("");
  const [downloadLimit, setDownloadLimit] = useState(0);
  const [openModule, setOpenModule] = useState("general");
  const [loader, setLoader] = useState(false);
  const [storeCategories, setStoreCategories] = useState([]);
  const [storeSubCategories, setStoreSubCategories] = useState([]);

  const addNewStoreProduct = async () => {
    setLoader(true);

    const userData = {
      name,
      slug,
      description,
      status,
      thumbnail,
      galary,
      categoryId,
      subCategoryId,
      tags,
      productType,
      regularPrice,
      salePrice,
      inventorySettings,
      shipplingSettings,
      relatedProduct,
      attributes,
      downloadURL,
      downloadLimit,
    };

    const data = await storeProductServices.addNewStoreProduct(userData);

    if (data?.statusCode === 200) {
      getStoreProductList();
      clearData();
      setAddNewProduct("");
    }

    setLoader(false);
  };

  const clearData = () => {
    setName("");
    setSlug("");
    setDescription("");
    setStatus("draft");
    setThumbnail(null);
    setGalary([]);
    setCategoryId("");
    setSubCategoryId("");
    setTags([]);
    setProductType("");
    setLoader(false);
    setRegularPrice("");
    setSalePrice("");
    setInventorySettings("");
    setShipplingSettings("");
    setRelatedProduct("");
    setAttributes([]);
    setDownloadURL("");
    setDownloadLimit("");
  };

  const addAttribute = () => {
    setAttributes([...attributes, { title: "", value: "" }]);
  };

  const removeAttribute = (index) => {
    const updated = attributes.filter((_, i) => i !== index);
    setAttributes(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...attributes];
    updated[index][field] = value;
    setAttributes(updated);
  };

  const getStoreCategoryList = async () => {
    setLoader(true);
    let data = await storeCategoryServices.getStoreCategoryList("active");
    setStoreCategories(data?.data || []);
  };

  const getStoreSubCategoryList = async () => {
    let data = await storeSubCategoryServices.getStoreSubCategoryList(
      categoryId,
      "active",
    );
    setStoreSubCategories(data?.data || []);
  };

  useEffect(() => {
    setName("");
    setSlug("");
    setDescription("");
    setStatus("draft");
    setThumbnail(null);
    setGalary([]);
    setCategoryId("");
    setSubCategoryId("");
    setTags([]);
    setProductType("");

    setLoader(false);
    setRegularPrice("");
    setSalePrice("");
    setInventorySettings("");
    setShipplingSettings("");
    setRelatedProduct("");
    setAttributes([]);
    setDownloadURL("");
    setDownloadLimit("");
    getStoreCategoryList();
  }, []);

  useEffect(() => {
    if (categoryId) {
      getStoreSubCategoryList();
    }
  }, [categoryId]);

  return (
    <>
      <div className="h-100 d-flex flex-column w-100">
        <div className="bg-white border-bottom py-2 px-3">
          <div className="hstack justify-content-between">
            <h6 className="fw-semibold m-0">Add New Product</h6>
            <button
              className="icon-btn danger"
              title="Close"
              onClick={() => setAddNewProduct("")}
            >
              <FaXmark />
            </button>
          </div>
        </div>
        <div className="flex-grow-1 overflow-auto bg-light">
          <Container fluid>
            <Row>
              <Form.Group
                as={Col}
                md={9}
                className="border-end overflow-auto py-2"
                style={{ height: "calc(100vh - 152px)" }}
              >
                <Form.Group className="mb-1">
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter product name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Form.Label>Product Url</Form.Label>
                  <Form.Control
                    type="url"
                    placeholder="Enter product URL"
                    value={slug}
                    onChange={(e) => setSlug(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Form.Label>Product Description</Form.Label>
                  <TextEditor
                    placeholder={"Write your store content here..."}
                    editorContent={description}
                    setEditorContent={(value) => setDescription(value)}
                  />
                </Form.Group>
                <Form.Group className="mb-1">
                  <Card>
                    <Card.Header className="border-0">
                      <Stack
                        direction="horizontal"
                        className="justify-content-between"
                      >
                        <Form.Label className="m-0">Product Data</Form.Label>
                        <Stack
                          direction="horizontal"
                          className="gap-2"
                          style={{ fontSize: 14 }}
                        >
                          <Form.Check type="checkbox" label="Vartual" />
                          <Form.Check type="checkbox" label="Download" />
                        </Stack>
                      </Stack>
                    </Card.Header>
                    <Card.Body className="p-0">
                      <Container fluid>
                        <Row>
                          <Form.Group
                            as={Col}
                            md={3}
                            className="border-end p-0"
                          >
                            <ListGroup
                              className="rounded-0"
                              style={{ fontSize: 12 }}
                            >
                              <ListGroup.Item
                                className="border-top border-0"
                                action
                                active={openModule === "general"}
                                onClick={() => setOpenModule("general")}
                              >
                                General
                              </ListGroup.Item>
                              <ListGroup.Item
                                action
                                className="border-top border-0"
                                active={openModule === "inventory"}
                                onClick={() => setOpenModule("inventory")}
                              >
                                Inventory
                              </ListGroup.Item>
                              <ListGroup.Item
                                action
                                className="border-top border-0"
                                active={openModule === "shipping"}
                                onClick={() => setOpenModule("shipping")}
                              >
                                Shipping
                              </ListGroup.Item>
                              <ListGroup.Item
                                action
                                className="border-top border-0"
                                active={openModule === "linkedProduct"}
                                onClick={() => setOpenModule("linkedProduct")}
                              >
                                Linked Product
                              </ListGroup.Item>
                              <ListGroup.Item
                                action
                                className="border-top border-0"
                                active={openModule === "attribute"}
                                onClick={() => setOpenModule("attribute")}
                              >
                                Attribute
                              </ListGroup.Item>
                            </ListGroup>
                          </Form.Group>
                          <Form.Group as={Col} md={9} className="border-top">
                            {openModule === "general" && (
                              <Row className="py-2">
                                <Col>
                                  <Form.Group className="mb-1">
                                    <Form.Label>Regular Price</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FiDollarSign />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="number"
                                        placeholder="Enter regular price"
                                        value={regularPrice}
                                        onChange={(e) =>
                                          setRegularPrice(e.target.value)
                                        }
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                                <Col>
                                  <Form.Group className="mb-1">
                                    <Form.Label>Sale Price</Form.Label>
                                    <InputGroup>
                                      <InputGroup.Text>
                                        <FiDollarSign />
                                      </InputGroup.Text>
                                      <Form.Control
                                        type="number"
                                        placeholder="Enter sale price"
                                        value={salePrice}
                                        onChange={(e) =>
                                          setSalePrice(e.target.value)
                                        }
                                      />
                                    </InputGroup>
                                  </Form.Group>
                                </Col>
                              </Row>
                            )}
                            {openModule === "inventory" && (
                              <div className="py-2">
                                <Form.Group className="mb-2">
                                  <Form.Label className="m-0">
                                    SKU Number
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter SKU number"
                                  />
                                </Form.Group>
                                <Row>
                                  <Col>
                                    <Form.Group className="mb-2">
                                      <Form.Label className="m-0">
                                        Manage Stock
                                      </Form.Label>
                                      <Form.Check
                                        type="checkbox"
                                        style={{ fontSize: 13 }}
                                        label="Manage stock leval quan"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col>
                                    <Form.Group className="mb-2">
                                      <Form.Label className="m-0">
                                        Sold Indivusually
                                      </Form.Label>
                                      <Form.Check
                                        type="checkbox"
                                        style={{ fontSize: 13 }}
                                        label="Limit purchase 1 item/per order"
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <Form.Group className="mb-2">
                                      <Form.Label className="m-0">
                                        Stock quality
                                      </Form.Label>
                                      <Form.Control
                                        type="text"
                                        placeholder="Enter stock quantity"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col>
                                    <Form.Group className="mb-2">
                                      <Form.Label className="m-0">
                                        Allow back order
                                      </Form.Label>
                                      <Form.Select>
                                        <option value={"no"}>No</option>
                                        <option value={"notify"}>
                                          Notify Customer
                                        </option>
                                        <option value={"yes"}>Yes</option>
                                      </Form.Select>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </div>
                            )}
                            {openModule === "shipping" && (
                              <div className="py-2">
                                <Form.Group className="mb-2">
                                  <Form.Label className="m-0">
                                    Weight (KG)
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter weight (kg)"
                                  />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                  <Form.Label className="m-0">
                                    Dimension (CM)
                                  </Form.Label>
                                  <InputGroup>
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter length (cm)"
                                    />
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter width (cm)"
                                    />
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter height (cm)"
                                    />
                                  </InputGroup>
                                </Form.Group>
                              </div>
                            )}
                            {openModule === "linkedProduct" && (
                              <Row className="py-2">
                                <Form.Group className="mb-2">
                                  <Form.Label className="m-0">
                                    Linked Product
                                  </Form.Label>
                                  <Form.Select>
                                    <option value={""}>Select Product</option>
                                  </Form.Select>
                                </Form.Group>
                              </Row>
                            )}
                            {openModule === "attribute" && (
                              <>
                                <Row className="py-2">
                                  <Form.Label className="m-0 d-flex align-items-center gap-2">
                                    Attribute
                                    <FiPlusSquare
                                      className="CP"
                                      title="Add Attribute"
                                      onClick={addAttribute}
                                    />
                                  </Form.Label>
                                </Row>
                                {attributes.map((attr, index) => (
                                  <Row key={index}>
                                    <Form.Group className="mb-2 w-100">
                                      <InputGroup>
                                        <Form.Control
                                          type="text"
                                          placeholder="Attribute title"
                                          style={{ width: "35%" }}
                                          value={attr.title}
                                          onChange={(e) =>
                                            handleChange(
                                              index,
                                              "title",
                                              e.target.value,
                                            )
                                          }
                                        />

                                        <Form.Control
                                          type="text"
                                          placeholder="Attribute value"
                                          style={{ width: "55%" }}
                                          value={attr.value}
                                          onChange={(e) =>
                                            handleChange(
                                              index,
                                              "value",
                                              e.target.value,
                                            )
                                          }
                                        />

                                        <InputGroup.Text
                                          title="Remove Attribute"
                                          className="CP"
                                          onClick={() => removeAttribute(index)}
                                        >
                                          <GoTrash className="text-danger" />
                                        </InputGroup.Text>
                                      </InputGroup>
                                    </Form.Group>
                                  </Row>
                                ))}
                              </>
                            )}
                          </Form.Group>
                        </Row>
                      </Container>
                    </Card.Body>
                  </Card>
                </Form.Group>
              </Form.Group>
              <Form.Group
                as={Col}
                md={3}
                className="overflow-auto p-0"
                style={{ height: "calc(100vh - 152px)" }}
              >
                <Form.Group className="p-2 border-bottom">
                  <Form.Label className="mb-1 fw-bold">Status</Form.Label>
                  <InputGroup>
                    <Form.Select
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value={"draft"}>Draft</option>
                      <option value={"publish"}>Published</option>
                    </Form.Select>
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={addNewStoreProduct}
                    >
                      Save
                    </Button>
                  </InputGroup>
                </Form.Group>
                <Form.Group className="p-2 border-bottom">
                  <Form.Label className="mb-1 fw-bold">Thumbnail</Form.Label>
                  <div title="Add Thumbnail">
                    <Button
                      variant="light"
                      className="w-100 border hstack gap-2 justify-content-center"
                      style={{ height: 108 }}
                    >
                      <div style={{ fontSize: 12 }}>
                        <FiPlus /> Add Thumbnail
                      </div>
                    </Button>
                  </div>
                </Form.Group>
                <Form.Group className="p-2 border-bottom">
                  <Form.Label className="mb-1 fw-bold hstack gap-3 justify-content-between">
                    Gallery
                    <div
                      style={{ fontSize: 12 }}
                      className="hstack gap-1 CP"
                      title="Add Gallery Images"
                    >
                      <FiPlusSquare /> Add Image
                    </div>
                  </Form.Label>
                  <Row className="g-2">
                    <Form.Group as={Col} md={4}>
                      <div title="Remove Image" className="position-relative">
                        <Button
                          variant="light"
                          className="border hstack justify-content-center p-2 w-100"
                        >
                          <img
                            src="https://rukminim2.flixcart.com/image/612/612/xif0q/lipstick/a/1/7/-original-imahjru97xuzmryz.jpeg?q=70"
                            height={50}
                            alt="Gallery Image"
                          />
                        </Button>
                        <div
                          className="bg-white position-absolute rounded-circle"
                          style={{ bottom: -5, right: -5 }}
                        >
                          <Button
                            variant="outline-danger"
                            className="rounded-circle p-0"
                            style={{ width: 20, height: 20 }}
                          >
                            <FaTrashAlt
                              style={{ fontSize: 10, marginBottom: 8 }}
                            />
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <div title="Remove Image" className="position-relative">
                        <Button
                          variant="light"
                          className="border hstack justify-content-center p-2 w-100"
                        >
                          <img
                            src="https://rukminim2.flixcart.com/image/612/612/xif0q/lipstick/l/s/h/-original-imahjru93q4yw74f.jpeg?q=70"
                            height={50}
                            alt="Gallery Image"
                          />
                        </Button>
                        <div
                          className="bg-white position-absolute rounded-circle"
                          style={{ bottom: -5, right: -5 }}
                        >
                          <Button
                            variant="outline-danger"
                            className="rounded-circle p-0"
                            style={{ width: 20, height: 20 }}
                          >
                            <FaTrashAlt
                              style={{ fontSize: 10, marginBottom: 8 }}
                            />
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <div title="Remove Image" className="position-relative">
                        <Button
                          variant="light"
                          className="border hstack justify-content-center p-2 w-100"
                        >
                          <img
                            src="https://rukminim2.flixcart.com/image/612/612/xif0q/lipstick/k/k/6/-original-imahjru9u2nzggzj.jpeg?q=70"
                            height={50}
                            alt="Gallery Image"
                          />
                        </Button>
                        <div
                          className="bg-white position-absolute rounded-circle"
                          style={{ bottom: -5, right: -5 }}
                        >
                          <Button
                            variant="outline-danger"
                            className="rounded-circle p-0"
                            style={{ width: 20, height: 20 }}
                          >
                            <FaTrashAlt
                              style={{ fontSize: 10, marginBottom: 8 }}
                            />
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <div title="Remove Image" className="position-relative">
                        <Button
                          variant="light"
                          className="border hstack justify-content-center p-2 w-100"
                        >
                          <img
                            src="https://tawk.link/5edc81e54a7c6258179a1405/var/logo/u30481uPlW.png"
                            height={50}
                            alt="Gallery Image"
                          />
                        </Button>
                        <div
                          className="bg-white position-absolute rounded-circle"
                          style={{ bottom: -5, right: -5 }}
                        >
                          <Button
                            variant="outline-danger"
                            className="rounded-circle p-0"
                            style={{ width: 20, height: 20 }}
                          >
                            <FaTrashAlt
                              style={{ fontSize: 10, marginBottom: 8 }}
                            />
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <div title="Remove Image" className="position-relative">
                        <Button
                          variant="light"
                          className="border hstack justify-content-center p-2 w-100"
                        >
                          <img
                            src="https://tawk.link/5edc81e54a7c6258179a1405/var/logo/u30481uPlW.png"
                            height={50}
                            alt="Gallery Image"
                          />
                        </Button>
                        <div
                          className="bg-white position-absolute rounded-circle"
                          style={{ bottom: -5, right: -5 }}
                        >
                          <Button
                            variant="outline-danger"
                            className="rounded-circle p-0"
                            style={{ width: 20, height: 20 }}
                          >
                            <FaTrashAlt
                              style={{ fontSize: 10, marginBottom: 8 }}
                            />
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                    <Form.Group as={Col} md={4}>
                      <div title="Remove Image" className="position-relative">
                        <Button
                          variant="light"
                          className="border hstack justify-content-center p-2 w-100"
                        >
                          <img
                            src="https://tawk.link/5edc81e54a7c6258179a1405/var/logo/u30481uPlW.png"
                            height={50}
                            alt="Gallery Image"
                          />
                        </Button>
                        <div
                          className="bg-white position-absolute rounded-circle"
                          style={{ bottom: -5, right: -5 }}
                        >
                          <Button
                            variant="outline-danger"
                            className="rounded-circle p-0"
                            style={{ width: 20, height: 20 }}
                          >
                            <FaTrashAlt
                              style={{ fontSize: 10, marginBottom: 8 }}
                            />
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                  </Row>
                </Form.Group>
                <Form.Group className="p-2 border-bottom">
                  <Form.Label className="mb-1 fw-bold">Category</Form.Label>
                  <Form.Select
                    value={categoryId}
                    onChange={(e) => setCategoryId(e.target.value)}
                  >
                    <option value="">Select Category</option>
                    {storeCategories?.map((cat) => (
                      <option key={cat.categoryId} value={cat.categoryId}>
                        {cat.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="p-2 border-bottom">
                  <Form.Label className="mb-1 fw-bold">Subcategory</Form.Label>
                  <Form.Select
                    value={subCategoryId}
                    onChange={(e) => setSubCategoryId(e.target.value)}
                  >
                    <option value="">Select Subcategory</option>
                    {storeSubCategories?.map((sub) => (
                      <option key={sub._id} value={sub._id}>
                        {sub.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="p-2 border-bottom">
                  <Form.Label className="mb-1 fw-bold">Tags</Form.Label>
                  <Multiselect
                    displayValue="label"
                    onKeyPressFn={() => {}}
                    onSearch={() => {}}
                    onSelect={(selectedList) => setTags(selectedList)}
                    onRemove={(selectedList) => setTags(selectedList)}
                    selectedValues={tags}
                    options={[
                      { label: "PDF File", value: ".pdf" },
                      { label: "MP3 File", value: ".mp3" },
                      { label: "MP4 File", value: ".mp4" },
                      { label: "PNG File", value: ".png" },
                      { label: "JPG File", value: ".jpg" },
                      { label: "JPEG File", value: ".jpeg" },
                      { label: "ZIP File", value: ".zip" },
                      { label: "RAR File", value: ".rar" },
                      { label: "XPT File", value: ".xpt" },
                      { label: "CSV File", value: ".csv" },
                      { label: "XLS File", value: ".xls" },
                      { label: "XLSX File", value: ".xlsx" },
                      { label: "DOC File", value: ".doc" },
                      { label: "DOCX File", value: ".docx" },
                      { label: "PPT File", value: ".ppt" },
                      { label: "PPTX File", value: ".pptx" },
                      { label: "TXT File", value: ".txt" },
                    ]}
                  />
                </Form.Group>
              </Form.Group>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default AddStoreProduct;
